import React, { useMemo } from "react";
import CommonPageLayout from "../../components/commonPageLayout/commonPageLayout";
import TabPage from "../../components/tab/tabPage";
import EncryptDecryptTool from "./EncryptDecryptTool"; // We'll move the tool to its own file for clarity
import FeatureSettings from "./FeatureSettings";
import { getUserRole } from "../../utils/commonFunctions";

const TechTabPage: React.FC = () => {
  const tabs = useMemo(() => {
    const accessToken = localStorage.getItem("accessToken") || "";
    const roles = getUserRole(accessToken);
    const isAdmin = roles.includes("Admin");

    const tabList = [
      {
        label: "ENCRYPT-DECRYPT",
        value: "1",
        component: <EncryptDecryptTool />
      }
    ];

    if (isAdmin) {
      tabList.push({
        label: "FEATURE FLAGS",
        value: "2",
        component: <FeatureSettings />
      });
    }

    return tabList;
  }, []);

  return <TabPage tabs={tabs} defaultTab="1" showRefresh={false} />;
};

const TechPage: React.FC = () => {
  return (
    <CommonPageLayout heading="Tech Tools">
      <TechTabPage />
    </CommonPageLayout>
  );
};

export default TechPage;
